<template>
	<section>
		<el-drawer v-bind="$attrs" v-on="$listeners" @opened="onOpen" class="drawer" :show-close="false">
			<el-row type="flex" slot="title" style="align-items:center;margin-bottom:0;">
				<h1>{{detail?detail.title:'查看详情'}}</h1>
				<div style="margin-left:auto;" v-if="$route.name=='formMyHistory'">
					<el-button type="primary" size="small" @click="toUpdate" v-if="is_show_edit">编辑</el-button>
					<el-button type size="small" @click="toRevoke" v-if="is_show_revoke">撤回</el-button>
					<el-button type size="small" @click="close">关闭</el-button>
				</div>
			</el-row>
			<el-main>
				<div v-if="detail.student" style="margin-bottom:20px;">
					<el-image :src="detail.student.avatar" class="small_avatar"></el-image>
					<span>{{detail.student.name}}</span>
					<span style="margin-left:10px;font-size:14px;"
						:style="{color:statusColor[detail.status]}">{{statusObj[detail.status]}}</span>
				</div>
				<div v-else-if="detail.applicant" style="margin-bottom:20px;">
					<el-image :src="detail.applicant.avatar" class="small_avatar"></el-image>
					<span>{{detail.applicant.name}}</span>
					<span style="margin-left:10px;font-size:14px;"
						:style="{color:statusColor[detail.status]}">{{statusObj[detail.status]}}</span>
				</div>

				<el-form :model="detail" v-if="lists.length">
					<el-form-item v-for="(item,key) in lists" :key="key" :label="item.label">
						<div v-if="item.category&&(item.category=='upload'||item.category=='signature')">
							<div v-if="item.category=='signature'" style="height:120px;">
								<el-image v-if="item.str" fit="scale-down" :src="item.str.path" class="write-img" />
							</div>
							<div v-else-if="item.accept&&item.accept=='image/*'">
								<el-image v-for="(img,i) in item.str" :src="img.path" :key="i"
									:preview-src-list="[img.path]" class="imgs" fit="contain"></el-image>
							</div>
							<div v-else style="display:inline-block">
								<div v-for="(file,i) in item.str" :key="i">
									<a :href="file.path">{{file.name}}</a>
								</div>
							</div>
						</div>
						<span v-else>{{item.str||''}}</span>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-row>
					<el-form>
						<el-row>
							<el-steps direction="vertical" status="process">
								<el-step v-if="detail.applicant" style="flex-basis:60px;" icon="el-icon-message-solid">
									<div slot="icon">
										<el-image :src="detail.applicant.avatar" class="small_avatar"
											style="margin-right:0;" />
									</div>
									<div slot="title" style="display:flex;">
										<span
											style="font-size:14px;color:#333333">{{info.id == detail.applicant.user_id?'我':detail.applicant.name}}
											发起申请</span>
										<span
											style="margin-left:auto;font-size:14px;">{{timeForLimitTime(detail.add_time)}}</span>
									</div>
								</el-step>
								<el-step :title="item.checker.name" v-for="(item,i) in detail.logs" :key="i"
									style="flex-basis:60px;">
									<div slot="icon">
										<el-image :src="item.checker.avatar" class="small_avatar"
											style="margin-right:0;" />
									</div>
									<div slot="title">
										<div style="display:flex;">
											<span style="font-size:14px;color:#333333">
												{{item.checker.name}}
												<span style="margin-left:10px;font-size:14px;"
													:style="{color:statusColor[item.status]}">{{statusObj[item.status]}}</span>
											</span>
											<span style="margin-left:auto;font-size:14px;">{{item.date}}</span>
										</div>
										<p style="font-size:14px;color:#a1a1a1;line-height:1.7;">{{item.comment}}</p>
									</div>
								</el-step>

								<el-step
									v-if="!(detail.logs&&detail.logs.length)&&detail.checkers&&detail.checkers.length"
									style="flex-basis:60px;" icon="el-icon-message-solid">
									<div slot="title" style="display:flex;">
										<span
											style="font-size:14px;color:#333333">{{detail.checkers.map(x=>x.name).join(',')}}</span>
										<span style="margin-left:10px;font-size:14px;color:#007AFF">待审核</span>
									</div>
								</el-step>

								<el-step style="flex-basis:60px;" v-if="detail.notifiers&&detail.notifiers.length"
									icon="el-icon-s-promotion">
									<div slot="title" style="display:flex;flex-direction:column;">
										<p style="font-size:14px;color:#666666">抄送{{detail.notifiers.length}}人</p>
										<div style="display:flex;flex-wrap:wrap;margin-top:10px;">
											<div v-for="(check,c) in detail.notifiers" :key="c"
												style="text-align:center;margin-right:15px;">
												<el-image :src="check.avatar" class="small_avatar"
													style="margin-right:0;" />
												<p style="font-size:12px;margin-top:5px;">{{check.name}}</p>
											</div>
										</div>
									</div>
								</el-step>
							</el-steps>
						</el-row>
					</el-form>
				</el-row>
				<el-divider></el-divider>

				<el-row v-if="is_check&&$route.name=='formMyCheck'">
					<el-input type="textarea" v-model="comment" :autosize="{ minRows:4}" placeholder="请输入评论"
						style="margin-bottom:10px;"></el-input>
					<el-button type="primary" plain @click="is_select=true">转审</el-button>
					<el-button type="warning" plain @click="toCheck('UNPASSED')">驳回</el-button>
					<el-button type="warning" @click="toCheck('REJECT')">拒绝</el-button>
					<el-button type="primary" @click="toCheck('APPROVAL')">通过</el-button>
				</el-row>
			</el-main>
		</el-drawer>

		<!-- 预览 -->
		<form-preview :visible.sync="drawerVisible" :form-data="formData" @submit="onOpen" type="update"
			:status="detail.status" size="50%" />

		<select-business :visible="is_select" business_type="teacher" :maxNumber="1" @closeSelect="is_select=false"
			@submit="submitChangeChecker"></select-business>
	</section>
</template>
<script>
	import { oa_approvals } from "@/api/oa";
	import { mapState } from "vuex";
	import formPreview from "@/components/form_custom/preview/index";
	import { cms_form } from "@/api/cms";
	import selectBusiness from "@/components/form/index/selectBusiness";
	import formatter from "@/mixins/formatter";
	export default {
		components: { formPreview, selectBusiness },
		mixins: [formatter],
		props: {
			apply_id: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				detail: {},
				lists: [],
				formData: {},
				drawerVisible: false,
				is_check: false, //是否审核状态
				is_select: false,
				statusObj: {
					// COMMIT: "已发起",
					REVOKE: "已撤回",
					PENDDING: "待审核",
					APPROVAL: "审核通过",
					UNPASSED: "驳回",
					REJECT: "已拒绝",
				},
				statusColor: {
					COMMIT: "#FFB356",
					REVOKE: "#333333",
					PENDDING: "#007AFF",
					APPROVAL: "#2EB6AA",
					UNPASSED: "#FF4A00",
					REJECT: "#FF0000",
				},
				comment: "",
			};
		},
		computed: {
			...mapState("user", ["info"]),
			is_show_edit() {
				return this.detail.applicant &&
					this.info.id == this.detail.applicant.user_id &&
					this.detail.status == "PENDDING" &&
					this.detail.status == "UNPASSED"
					? true
					: false;
			},
			is_show_revoke() {
				return this.detail.applicant &&
					this.info.id == this.detail.applicant.user_id &&
					this.detail.status == "PENDDING"
					? true
					: false;
			},
		},
		watch: {},
		created() { },
		mounted() { },
		beforeDestroy() { },
		methods: {
			submitChangeChecker(data) {
				let userid = data && data.length ? data[0].value : null;
				if (!userid) {
					return;
				}
				if (userid == this.info.id) {
					this.$notify({
						title: "提示",
						type: "success",
						duration: 4000,
						message: `不能转审给自己！`,
					});
					return;
				}
				this.$confirm("确定要转审？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					oa_approvals
						.toChecker({ id: this.apply_id, user_id: userid })
						.then((res) => {
							if (res.data) {
								this.$notify({
									title: "提示",
									type: "success",
									duration: 2000,
									message: `转审成功！`,
								});
								this.close(1);
							}
						});
				});
			},
			toCheck(type) {
				let obj = {
					APPROVAL: "通过",
					REJECT: "拒绝",
					UNPASSED: "驳回",
				};
				let text = "确定" + obj[type] + "?";
				this.$confirm(text, "提示", {
					confirmButtonText: obj[type],
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					oa_approvals
						.examine({
							id: this.apply_id,
							status: type,
							comment: this.comment,
						})
						.then((res) => {
							if (res.data) {
								this.$notify({
									title: "提示",
									type: "success",
									duration: 2000,
									message: `审核状态：${obj[type]}`,
								});
								this.close(1);
							}
						});
				});
			},
			onOpen() {
				if (!this.apply_id) {
					return;
				}
				this.drawerVisible = false;
				this.is_check = false;
				this.comment = "";
				this.lists = [];
				oa_approvals.get({ id: this.apply_id }).then((res) => {
					if (res.data) {
						this.detail = res.data.data;

						if (
							this.detail.status == "PENDDING" &&
							this.detail.checkers &&
							this.detail.checkers.length
						) {
							this.is_check =
								this.detail.checkers.findIndex(
									(e) => e.user_id == this.info.id
								) > -1
									? true
									: false;
						}

						let field_keys = res.data.field_keys;
						if (this.detail.content) {
							field_keys.forEach((r) => {
								let item = this.detail.content[r] || null;
								if (item) {
									this.lists.push(item);
								}
							});
						}
					}
				});
			},
			close(val) {
				this.$emit("close", val);
			},
			toRevoke() {
				this.$confirm("确定要撤回?", "提示", {
					confirmButtonText: "撤回",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					oa_approvals.revoke({ id: this.apply_id }).then((res) => {
						if (res.data) {
							this.$notify({
								title: "提示",
								type: "success",
								duration: 2000,
								message: "撤回成功!",
							});
							this.close(1);
						}
					});
				});
			},
			toUpdate() {
				let result = this.detail.content;
				cms_form.get({ id: this.detail.form_id }).then((arr) => {
					if (arr.data) {
						let formValue = arr.data;
						if (
							formValue.config &&
							formValue.config.fields &&
							formValue.config.fields.length > 0
						) {
							formValue.config.fields.forEach((r) => {
								let had_val = result[r.__vModel__]
									? result[r.__vModel__].value
									: null;
								r.__config__.defaultValue = had_val;

								// 处理业务组件显示
								if (
									r.category == "selectBusiness" &&
									had_val &&
									had_val.length
								) {
									r.__slot__.default = "已选择" + had_val.length;
								}
							});
						}
						this.formData = Object.assign(formValue, {
							apply_id: this.apply_id,
						});
						this.drawerVisible = true;
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.el-main {
		margin: 0 20px;
		height: calc(100% - 50px);
	}
	.drawer /deep/ .el-drawer__header {
		margin-bottom: 0px;
	}
	.el-form-item {
		margin-bottom: 0px;
	}
	.el-form-item /deep/ .el-form-item__label {
		color: #999999;
	}
	.el-form-item /deep/ .el-form-item__content {
		display: flex;
	}
	.imgs {
		width: 98px;
		height: 98px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	.el-tag {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.write-img {
		transform: rotate(-90deg);
		display: inline-block;
		transform-origin: 80px 50px;
	}
	/deep/ .el-steps--vertical {
		height: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/form_custom/preview/detail.vue